import { dynamicParameter } from '@/mixins/service/mixin-service';
import cloneDeep from 'lodash/cloneDeep';
import dateFormatter from '@/services/formatter_services/date-formatter';
import get from 'lodash/get';
import restUtils from '@/utils/rest-utils.js';
import { formatBlobAsJson } from '@/utils/shared';
import axios from 'axios';
import { mapActions } from 'vuex';
import SNACKBAR_TYPES from '@/utils/enum/SNACKBAR_TYPES';

export default function (tableName = '') {
    const getTableName = dynamicParameter(tableName);

    return {
        methods: {
            ...mapActions('globalSnackbarStore', ['showSnackbarWithMessage']),
            deepGet(obj, path) {
                return get(obj, path) ?? get(obj?.data, path);
            }, 
            fetchZipData() {
                let sortOptions = {};
                for (let i = 0; i < this.sortBy.length; i++) {
                    sortOptions[this.sortBy[i]] = this.sortDesc[i];
                }
                const processedFilters = cloneDeep(this.filters) ?? [];
                for (const [key, value] of Object.entries(processedFilters)) {
                    if (Array.isArray(value)) {
                        processedFilters[key] = value.map(v => encodeURIComponent(v)).join(',');
                    }
                }
                if (this.search)
                    processedFilters['search'] = this.search

                axios.get('/rest/v4/' + this.path + '/download', {
                    params: {
                    ...processedFilters,
                    ...this.mandatoryFilters,
                    sort: restUtils.convertSortOptionsToQueryParam(sortOptions),
                    page: 0,
                    size: 9999
                    },
                    responseType: 'blob',
                })
                .then((response) => {
                    let fileName = dateFormatter.getLocalDateTimeStringNowForFileName() + '_' + getTableName(this) + '_Dateien.zip';
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;                    
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(async (error) => {
                    const errorAsJson = await formatBlobAsJson(error.response.data);
                    this.showSnackbarWithMessage({
                        type: SNACKBAR_TYPES.ERROR,
                        message: errorAsJson.message,
                    });
                });
            },
        },
    }
}